import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import {
  debounce,
  getDayjsObject,
  getOptionsFromRefList,
  getRefListNameByID,
  isNonEmptyVariable,
  hasCheckSecurity,
} from "@/util/common_function";
import { Form } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";

const Administrator = ({
  data,
  updateForm = null,
  parentFieldEnable = false,
  fromkey = "",
}) => {
  const { userDetail } = useSelector((s) => s?.userDetail);
  const { bookingsFieldsEnabled } = useSelector((state) => state?.bookings);
  const [form] = Form.useForm();
  const [administratorData, setAdministratorData] = useState(null);

  const status = Form.useWatch(
    isNonEmptyVariable(fromkey)
      ? [fromkey, 0, "administratorStatus"]
      : "administratorStatus",
    form,
  );

  useEffect(() => {
    if (isNonEmptyVariable(data)) {
      setAdministratorData({
        ...data,
        administratorStaff: isNonEmptyVariable(data?.administratorStaffId)
          ? getRefListNameByID("", data?.administratorStaffId, true, true)
          : "",
        administratorDateTime: getDayjsObject(
          data?.administratorDate,
          data?.administratorTime,
        ),
      });
    }
  }, [data]);

  useEffect(() => {
    if (isNonEmptyVariable(administratorData)) {
      if (isNonEmptyVariable(fromkey)) {
        form.setFieldsValue({
          [fromkey]: [administratorData],
        });
      } else {
        form.setFieldsValue(administratorData);
      }
    }
  }, [administratorData]);

  const dataModify = debounce(async () => {
    const formValues = await form.validateFields();
    let values = formValues;
    if (isNonEmptyVariable(fromkey)) {
      values = formValues?.[fromkey]?.[0];
    }
    const _administratorDateTime = values?.administratorDateTime
      ? dayjs(values?.administratorDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    const data = {
      ...values,
      administratorDate: _administratorDateTime?.split(" ")?.[0],
      administratorTime: _administratorDateTime?.split(" ")?.[1],
    };

    delete data?.administratorDateTime;

    updateForm(data);
  }, 800);

  const changeStatus = (e) => {
    if (!isNonEmptyVariable(e)) return;
    form.setFieldValue(
      isNonEmptyVariable(fromkey)
        ? [fromkey, 0, "administratorDateTime"]
        : "administratorDateTime",
      dayjs(),
    );
    form.setFieldValue(
      isNonEmptyVariable(fromkey)
        ? [fromkey, 0, "administratorStaffId"]
        : "administratorStaffId",
      userDetail?.staffId,
    );
    form.setFieldValue(
      isNonEmptyVariable(fromkey)
        ? [fromkey, 0, "administratorRejectReason"]
        : "administratorRejectReason",
      "",
    );
  };

  const hasAdminPermission = hasCheckSecurity(
    Security_Types.functionality,
    "Arbitrary",
    LABELS_CAPITAL.ADD,
    "Admin-View",
  );
  // const options = getOptionsFromRefList("JailIncidentsStatusAdministrator");
  
  // useEffect(() => {
  //   if (!hasAdminPermission) {

  //     const pendingOption = options?.find(
  //       (opt) => opt.label === "Pending"
  //     );

  //     if (pendingOption) {

  //       const fieldPath = isNonEmptyVariable(fromkey)
  //         ? [fromkey, 0, "administratorStatus"]
  //         : "administratorStatus";

  //       form.setFieldValue(fieldPath, pendingOption.value);
  //     }
  //   }
  // }, [hasAdminPermission]);

  const allOptions = getOptionsFromRefList("JailIncidentsStatusAdministrator");

  const filteredOptions = !hasAdminPermission
    ? allOptions?.filter(
        (opt) => opt.label?.trim().toLowerCase() === "pending"
      )
    : allOptions;

  return (
    <>
      <StyledSectionHeading marginBottom="15px">
        <span>Administrator</span>
      </StyledSectionHeading>
      <Form
        form={form}
        onFieldsChange={() => {
          if (isNonEmptyVariable(updateForm)) dataModify();
        }}
      >
        <StyledGridRow gutter={[16]}>
          <StyledGridCol lg={12}>
            <FormItem
              label="Administrator Name"
              name={
                isNonEmptyVariable(fromkey)
                  ? [fromkey, 0, "administratorStaffId"]
                  : "administratorStaffId"
              }
            >
              <Select
                id="administratorStaffId"
                options={getOptionsFromRefList("", true, false, true)}
                placeholder="Select Administrator"
                disabled={!bookingsFieldsEnabled || !parentFieldEnable }
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem
              label="Status"
              name={
                isNonEmptyVariable(fromkey)
                  ? [fromkey, 0, "administratorStatus"]
                  : "administratorStatus"
              }
            >
              <Select
                id="AdministratorStatus"
                options={filteredOptions}
                placeholder="Select Status"
                onChange={changeStatus}
                disabled={!bookingsFieldsEnabled || !parentFieldEnable }
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem
              label="Date & Time"
              name={
                isNonEmptyVariable(fromkey)
                  ? [fromkey, 0, "administratorDateTime"]
                  : "administratorDateTime"
              }
            >
              <CommonDatePicker
                id="reportingDateTime"
                format="MM/DD/YYYY HH:mm"
                disabled={!bookingsFieldsEnabled || !parentFieldEnable }
              />
            </FormItem>
          </StyledGridCol>
          {status === "Rejected" && (
            <StyledGridCol xs={24} lg={24}>
              <FormItem
                label="Reject Reason"
                name={
                  isNonEmptyVariable(fromkey)
                    ? [fromkey, 0, "administratorRejectReason"]
                    : "administratorRejectReason"
                }
              >
                <TextField
                  inputType="textarea"
                  rows="2"
                  disabled={!bookingsFieldsEnabled || !parentFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
          )}
        </StyledGridRow>
      </Form>
    </>
  );
};

export default Administrator;
